import { styled } from 'styled-components';
import { getCDNImageUrl } from '@/helpers/cdn';
import { hexToRGB, typography } from '@/styles/helpers';

const successIcon = getCDNImageUrl('/icon-img/tickCircleIcon.svg');
const warningIcon = getCDNImageUrl('/icon-img/warningIcon.svg');

export const ScReceiveBonusesNotice = styled.div<{ enabled: boolean }>`
  width: 100%;
  padding: 12px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
  background-color: ${({ theme, enabled }) =>
    enabled ? theme.grayDarkColor : hexToRGB(theme.blackColor, 0.6)};
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  margin-inline: auto;

  & > .icon {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    min-width: 32px;
  }

  .success-icon {
    background: ${() => `url(${successIcon}) center no-repeat`};
  }

  .warning-icon {
    background: ${() => `url(${warningIcon}) center no-repeat`};
  }

  & .text {
    flex: 1;
    color: ${({ theme }) => theme.whiteColor};
    & > .title {
      ${typography['body2bold']};
    }

    & > .message {
      ${typography['caption1regular']};
      color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};

      & > span {
        letter-spacing: 0.14px;
        color: ${({ theme }) => theme.secondaryColor};
        text-decoration-line: underline;
        margin-left: 4px;
        font-weight: 700;
        cursor: pointer;
      }
    }
  }
`;
